import { render, staticRenderFns } from "./ControlDevicesList.vue?vue&type=template&id=b6fa65e8"
import script from "./ControlDevicesList.vue?vue&type=script&lang=ts"
export * from "./ControlDevicesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports